__turbopack_context__.v({
  "indicator": "Pills-module__Bkl_Wq__indicator",
  "tab": "Pills-module__Bkl_Wq__tab",
});
